module.exports = "<div class=\"ellipsis\"><div>\n  <p><%= text %><i></i></p><p></p>\n</div></div>"